/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class IsTor extends RiskFactor {
    icon = 'close-s';

    className = 'icon-red';

    label = 'Order Placed From';

    result = 'Tor';

    static getCondition({isTor}) {
        return !!isTor;
    }

    parse({isTor}) {
        this.isTor = isTor;
    }

    getResult() {
        return this.result;
    }
}
